import {User} from "./user.model";
import {RxChain} from "./rx-chain";

export type LoginChainFn = (email: string, password: string) => RxChain<User>;

export enum ModuleEnum {
  FALCON = 'FALCON',
  FRAMEWORK = 'FRAMEWORK',
  HORUS = 'HORUS',
  ADMINISTRADOR = 'ADMINISTRADOR',
}

export class ModuleModel {
  constructor(
    public readonly id: number,
    public readonly name: ModuleEnum,
    public readonly logoImgPath: string | null,
    public readonly path: string,
    private readonly _loginChainFactory: LoginChainFn
  ) {
  }

  loginChain(email: string, password: string): RxChain<User> {
    return this._loginChainFactory(email, password);
  }
}

export function getByString(name: string): ModuleEnum {
  return (ModuleEnum as any)[name];
}
